import {
 Environment
} from '@vodacom/web-env';

import {
 AppState,
 getStorageWithExpiry,
 isValidEncMsisdn
} from 'helpers';

import {
 CacheStrategy
} from 'constants';

export class SubscriptionProvisionProvider {
  static BASE_URL = Environment.current.apiHost;
  static STATE = AppState.with('SubscriptionProvisionProvider');
  static DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  static getMsisdn() {
    return getStorageWithExpiry('msisdn', 'encMsisdn', '');
  }

  static async provisionBundle(soid) {
    if (!isValidEncMsisdn(SubscriptionProvisionProvider.getMsisdn())) {
      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return SubscriptionProvisionProvider.STATE.makeServiceCall(
      `${SubscriptionProvisionProvider.BASE_URL}/subscription/provision/${soid}`,
      {
        method: 'POST',
        headers: {
          ...SubscriptionProvisionProvider.DEFAULT_HEADERS
        },
        pathParams: {
          soid: soid
        },
        bodyParams: {
          id: SubscriptionProvisionProvider.getMsisdn()
        },
        cacheStrategy: CacheStrategy.None
      }
    )
      .then((res) => {
        if (!res?.ok) {
          return {
            ok: false,
            error: new Error('provisioning of social bundle error'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {
        return {
          ok: false,
          error: error?.response?.data?.result,
          trace: null,
          date: null,
          result: null,
          code: error?.response?.status,
          stamp: new Date()
        };
      });
  }
}
